var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "page-header",
        {
          attrs: {
            title: _vm.$t("pages.admin.blog.index.title"),
            "icon-class": "mdi mdi-television"
          }
        },
        [
          _c(
            "div",
            { staticClass: "text-right" },
            [
              _c(
                "router-link",
                {
                  staticClass: "text-primary font-weight-bold",
                  attrs: { tag: "a", to: { name: "admin.blog.create" } }
                },
                [
                  _c("i", { staticClass: "mdi mdi-plus" }),
                  _vm._v(
                    " " + _vm._s(_vm.$t("actions.create")) + "\n            "
                  )
                ]
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "card shadow-sm" }, [
        _c(
          "div",
          { staticClass: "card-body" },
          [
            _c("div", { staticClass: "table-responsive" }, [
              _c(
                "table",
                { staticClass: "table table-striped table-borderless" },
                [
                  _c("thead", [
                    _c("tr", [
                      _c("th", [
                        _vm._v(_vm._s(_vm.$t("pages.admin.blog.model.title")))
                      ]),
                      _vm._v(" "),
                      _c("th", [
                        _vm._v(
                          _vm._s(_vm.$t("pages.admin.blog.model.files_count"))
                        )
                      ]),
                      _vm._v(" "),
                      _c("th", [
                        _vm._v(
                          _vm._s(_vm.$t("pages.admin.blog.model.date_and_time"))
                        )
                      ]),
                      _vm._v(" "),
                      _c("th", [_vm._v(_vm._s(_vm.$t("actions.actions")))])
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "tbody",
                    _vm._l(_vm.blogPosts, function(blogpost) {
                      return _c("tr", [
                        _c("td", [
                          _c("img", {
                            staticClass: "img-thumbnail mr-2",
                            attrs: {
                              src: blogpost.thumbnail_url,
                              alt: blogpost.title
                            }
                          }),
                          _vm._v(
                            "\n                            " +
                              _vm._s(blogpost.title) +
                              "\n                        "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [_vm._v(_vm._s(blogpost.files.length))]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            _vm._s(
                              _vm
                                .$date(blogpost.created_at)
                                .format("DD.MM.YYYY HH:mm")
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "td",
                          [
                            _c(
                              "router-link",
                              {
                                staticClass: "btn btn-outline-warning btn-sm",
                                attrs: {
                                  tag: "button",
                                  to: {
                                    name: "admin.blog.edit",
                                    params: { postId: blogpost.id }
                                  }
                                }
                              },
                              [_c("i", { staticClass: "mdi mdi-pencil" })]
                            ),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass:
                                  "btn btn-outline-danger btn-sm float-right",
                                on: {
                                  click: function($event) {
                                    _vm.selectedBlogPost = blogpost
                                  }
                                }
                              },
                              [_c("i", { staticClass: "mdi mdi-trash-can" })]
                            )
                          ],
                          1
                        )
                      ])
                    }),
                    0
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "mt-3" },
              [
                _c("pagination", {
                  attrs: { data: _vm.paginationData },
                  on: { "pagination-change-page": _vm.getBlogPosts }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c("blog-delete-modal", {
              attrs: { selected: _vm.selectedBlogPost },
              on: {
                "post-deleted": _vm.onBlogPostDeleted,
                "modal-close": function($event) {
                  _vm.selectedBlogPost = null
                }
              }
            })
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }